import { hydrateRailsRoot } from '@unisporkal/federation';
import { sendBrowserError } from '@unisporkal/instrumentation';
import { APP_NAME } from 'src/constants';
import { initAttrTracking } from 'src/react/config/tracking';
import { getRoutes } from 'src/react/shared/routes';
import siteComponent from './siteComponent';

initAttrTracking();

const loadJSONPayload = (componentName) => {
  try {
    const element = document.querySelector(
      `script[data-component=${componentName}]`
    );
    if (!element) return {};
    return JSON.parse(element.innerHTML);
  } catch (error) {
    sendBrowserError(error);
    return {};
  }
};

const element = document.querySelector(
  `[data-component][data-federated-component='false']`
);

if (!element) {
  const error = new Error('No react root element found in DOM');
  sendBrowserError(error);
  throw error;
}

const siteName = window.currentSite.nickname;

const componentName = element.getAttribute('data-component');
const payload = loadJSONPayload(componentName);

const routes = getRoutes(siteName, componentName, siteComponent, payload);
hydrateRailsRoot(APP_NAME, routes, componentName, element);
